import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import RideFormOne from '../FreeRideForm/RideFormOne';
import RideFormTwo from '../FreeRideForm/RideFormTwo';
import RideFormThree from '../FreeRideForm/RideFormThree';
import RideFormFour from '../FreeRideForm/RideFormFour';
import RideFormFive from '../FreeRideForm/RideFormFive';
import RideFormSix from '../FreeRideForm/RideFormSix';
import { styled } from "@mui/material/styles"
import Check from '@mui/icons-material/Check';
import StepLabel from '@mui/material/StepLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import ThankYouComponent from '../ThankYouComponent/ThankYouComponent';
import { Modal } from '@mui/material';
import ProgressBar from '../ProgressBar/ProgressBar';
import RideFormSeven from 'Component/FreeRideForm/RideFormSeven';

const steps = ['1', '2', '3', "4", "5", "6","7"];

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#021b38',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#021b38',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#97c11e',
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));
const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#97c11e',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  ...(ownerState.active && {
    color: '#021b38',
  }),
  '& .QontoStepIcon-completedIcon': {
    color: '#021b38',
    zIndex: 1,
    fontSize: 18,
  },
  '& .QontoStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
}));



export default function FreeRideStepper({ SetValue }) {
const [progress,setProgress] = React.useState(0)
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});
  const [freeRideData, setFreeRideData] = React.useState({
    started_from: new Date().toISOString().split('T')[0],
    first_name: "",
    last_name: "",
    company: "",
    email: "",
    password:"",
    phone: "",
    patient_name: "",
    patient_relation: "",
    patient_age: "",
    transport_date: "",
    street_name: "",
    city_state: "",
    receiving_facility: "",
    additional_info: ""

  })
  function QontoStepIcon(props) {
    const { active, completed, className } = props;

    return (
      <QontoStepIconRoot ownerState={{ active }} className={className}>
        {completed ? (
          <Check className="QontoStepIcon-completedIcon" />
        ) : (
          <div className="QontoStepIcon-circle" />
        )}
      </QontoStepIconRoot>
    );
  }
  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };
  console.log(completed)
  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ?
        steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    if (activeStep === 0) {
      SetValue(false)
    } else {


      setActiveStep((prevActiveStep) => prevActiveStep - 1);
      let keys = Object.keys(completed);
      if (keys.length > 0) {
        let lastElement = keys[keys.length - 1]
        delete completed[lastElement]
      }
    }
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };
  React.useEffect(()=>{
    const interval = setInterval(()=>{
      const progress = localStorage.getItem("progress")
      if(progress !==null){
        setProgress(progress)

      }
    },100)
    return ()=>{
      clearInterval(interval)
    }
  },[])

  return (
    <Box sx={{ width: '100%' }}>

      {/* <Stepper nonLinear activeStep={activeStep}>
        {steps.map((label, index) => (
          <Step key={label} completed={completed[index]}>
            <StepButton color="inherit" onClick={handleStep(index)}>
              
            </StepButton>
          </Step>
        ))}
      </Stepper> */}
      <Stepper alternativeLabel sx={{ display: allStepsCompleted() ? "none" : "flex" }} activeStep={activeStep} connector={<QontoConnector />}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={QontoStepIcon}></StepLabel>
          </Step>
        ))}
      </Stepper>
      <div>
        {allStepsCompleted() ? (
          <React.Fragment>
            {progress < 100 ?

              <Box sx={{ display: "flex", justifyContent: "center" }}  >
                <ProgressBar progress={progress} />
              </Box>
              :
              <Modal open={true} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }} >
                <ThankYouComponent />
              </Modal>
            }
          </React.Fragment>
        ) : (

          <React.Fragment>
            <Box  >
              {activeStep === 0 ? <RideFormOne handleBack={handleBack} handleComplete={handleComplete} freeRideData={freeRideData} setFreeRideData={setFreeRideData} /> :
              activeStep === 1 ? <RideFormSeven handleBack={handleBack} handleComplete={handleComplete} freeRideData={freeRideData} setFreeRideData={setFreeRideData} /> :
                activeStep === 2 ? <RideFormTwo handleBack={handleBack} handleComplete={handleComplete} freeRideData={freeRideData} setFreeRideData={setFreeRideData} /> :
                  activeStep === 3 ? <RideFormThree handleBack={handleBack} handleComplete={handleComplete} freeRideData={freeRideData} setFreeRideData={setFreeRideData} /> :
                    activeStep === 4 ? <RideFormFour handleBack={handleBack} handleComplete={handleComplete} freeRideData={freeRideData} setFreeRideData={setFreeRideData} /> :
                      activeStep === 5 ? <RideFormFive handleBack={handleBack} handleComplete={handleComplete} freeRideData={freeRideData} setFreeRideData={setFreeRideData} /> :
                        activeStep === 6 ? <RideFormSix handleBack={handleBack} handleComplete={handleComplete} freeRideData={freeRideData} setFreeRideData={setFreeRideData}  /> :
                          ""}
            </Box>

          </React.Fragment>

        )}
      </div>







    </Box>
  );
}